export const SET_SHOULD_RENDER = 'SET_SHOULD_RENDER'
